import React from 'react';
// import ExpandableListItem from '../../../../components/molecules/expandable_element';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';
import { Roles } from 'config';

interface IProps {
  vat_number: string | null;
  originatingCountry: string | null;
  schemeType: string | null;
  role: Roles;
}

const Filter = (props: IProps) => {
  const classes = useStyles();

  const Header = () => {
    return (
      <div className={classes.filter_header} style={{ marginTop: '0.5rem' }}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
    );
  };

  const Body = () => {
    return (
      <FilterForm
        vat_number={props.vat_number}
        originatingCountry={props.originatingCountry}
        schemeType={props.schemeType}
        role={props.role}
      />
    );
  };

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      {/* <ExpandableListItem
        renderDataHeader={() => <Header />}
        renderDataBody={() => <Body />}
      /> */}
      <Header />
      <Body />
    </div>
  );
};

export default Filter;
